import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyBoliaLeftNavigation = _resolveComponent("MyBoliaLeftNavigation")!
  const _component_PageRenderTransitionHandler = _resolveComponent("PageRenderTransitionHandler")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["w-full", { 'flex flex-nowrap px-x3 xl:px-x8': _ctx.isPageWithLeftNavigation }])
  }, [
    (_ctx.isPageWithLeftNavigation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.myBoliaLeftNavigationEnabled)
            ? (_openBlock(), _createBlock(_component_MyBoliaLeftNavigation, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageRenderTransitionHandler, {
      class: "flex-1",
      "is-changing-page": _ctx.isChangingPage
    }, {
      default: _withCtx(() => [
        (_ctx.resolvedPage)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resolvedPage), {
              key: _ctx.alias,
              content: _ctx.content,
              alias: _ctx.alias
            }, null, 8, ["content", "alias"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-changing-page"])
  ], 2))
}